import { render, staticRenderFns } from "./FeatureIcon.vue?vue&type=template&id=593c6366&scoped=true&"
import script from "./FeatureIcon.vue?vue&type=script&lang=js&"
export * from "./FeatureIcon.vue?vue&type=script&lang=js&"
import style0 from "./FeatureIcon.vue?vue&type=style&index=0&id=593c6366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c6366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
